import { useLenis } from "../hooks/useLenis";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { WhatsAppFloat } from "../components/WhatsAppFloat";
import { Hero } from "../sections/Hero";
import { CredibilityStrip } from "../sections/CredibilityStrip";
import { EditorialMarquee } from "../sections/EditorialMarquee";
import { QuemSomos } from "../sections/QuemSomos";
import { Services } from "../sections/Services";
import { ComoFunciona } from "../sections/ComoFunciona";
import { Differentiators } from "../sections/Differentiators";
import { AuthorityProof } from "../sections/AuthorityProof";
import { FAQ } from "../sections/FAQ";
import { FinalCTA } from "../sections/FinalCTA";

export default function Home() {
  useLenis();

  return (
    <div className="bg-cream text-ink" data-testid="home-page">
      <div className="grain-overlay" />
      <Header />
      <Hero />
      <CredibilityStrip />
      <EditorialMarquee />
      <QuemSomos />
      <Services />
      <ComoFunciona />
      <Differentiators />
      <AuthorityProof />
      <FAQ />
      <FinalCTA />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
